import React from "react";
import { createRoot } from "react-dom/client";
import { LiveTimetable } from "./components/LiveTimetable";
import { Languages } from './types';

const element = document.getElementById("live-timetable");

if (element) {
  createRoot(element).render(
    <LiveTimetable
      labels={JSON.parse(element.dataset.labels!)}
      routes={JSON.parse(element.dataset.routes!)}
      index={parseInt(element.dataset.index!)}
      lang={element.dataset.lang! as Languages}
    />
  );
}
